"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DatePicker_1 = require("./DatePicker");
exports.default = DatePicker_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/DatePicker/index.js
// module id = 1142
// module chunks = 8